import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-navigation-arrow-to-right-icon',
  templateUrl: './navigation-arrow-to-right.component.html'
})
export class NavigationArrowToRightComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
